<template>
    <div>
        <h2 class="t-c" v-if="financial_movements.length === 0">Não há lançamentos financeiros para essa proposta</h2>

        <table v-if="$appUtils.isDesktop() && financial_movements.length > 0" class="table table-hover table-striped table-sm table-bordered">
            <thead class="thead-dark thead-center">
            <tr>
                <th style="width: 40px">TIPO</th>
                <th style="width: 60px">PAGO?</th>
                <th style="width: 80px">VALOR</th>
                <th>IDENTIFICADOR</th>
                <th style="width: 90px">EMISSÃO</th>
                <th style="width: 110px">VENCIMENTO</th>
                <th style="width: 110px">PAGAMENTO</th>
                <th>NFs</th>
                <th>OBSERVAÇÕES</th>
            </tr>
            </thead>
            <tbody v-if="financial_movements">
            <tr v-for="fm in financial_movements" :key="fm.id">
                <td class="v-m c-p t-c" @click="showModal(fm)">
                    <span class="icon" :class="{in: fm.in, out: !fm.in}">
                        <svg-icon :icon="fm.in ? 'arrow-down' : 'arrow-up'"/>
                    </span>
                </td>
                <td class="v-m c-p t-c" @click="showModal(fm)">
                    <span class="paid" :class="{in: fm.paid, out: !fm.paid}">
                        <svg-icon :icon="fm.paid ? 'thumbs-up' : 'thumbs-down'"/>
                    </span>
                </td>
                <td class="v-m c-p t-r f-w-700" @click="showModal(fm)">{{fm.value | formatMoney}}</td>
                <td class="v-m c-p" @click="showModal(fm)">{{fm.identifier}}</td>
                <td class="v-m c-p t-c" @click="showModal(fm)">{{fm.emitted_at | formatDate}}</td>
                <td class="v-m c-p t-c" @click="showModal(fm)">{{fm.scheduled_to | formatDate}}</td>
                <td class="v-m c-p t-c" @click="showModal(fm)">{{fm.paid_at | formatDate}}</td>
                <td class="v-m inv">
                    <a @click="() => showModal(fm)"
                       v-for="inv in fm.financial_movement_invoices_attributes"
                       :key="inv.invoice.number">Nota {{inv.invoice.number}}</a>
                </td>
                <td class="v-m c-p ellipsis" @click="showModal(fm)">{{fm.description}}</td>
            </tr>
            </tbody>
        </table>

        <div v-if="$appUtils.isMobile()" class="fin-item" v-for="fm in financial_movements">
            <span class="ident">{{fm.identifier}}</span>
            <span class="value">
                {{fm.value | formatMoney}}
                <span class="icon" :class="{in: fm.in, out: !fm.in}">
                    <svg-icon :icon="fm.in ? 'arrow-down' : 'arrow-up'"/>
                </span>
                <span class="paid" :class="{in: fm.paid, out: !fm.paid}">
                    <svg-icon :icon="fm.paid ? 'thumbs-up' : 'thumbs-down'"/>
                </span>
            </span>
            <span class="emit">Emissão<br/>{{fm.emitted_at | formatDate}}</span>
            <span class="sched">Agendado<br>{{fm.scheduled_to | formatDate}}</span>
            <span class="paid">Pago<br>{{fm.paid_at | formatDate}}</span>
            <div class="inv" v-if="fm.invoices && fm.invoices.length > 0">
                Notas Fiscais<br/>
                <div><router-link :to="`/invoices/${inv.id}`" v-for="inv in fm.invoices">Nota {{inv.number}}</router-link></div>
            </div>
            <div class="notes">{{fm.description}}</div>
        </div>
    </div>
</template>

<script>
    import SelectX from '@/components/particles/SelectX'
    import {EventBus} from "../../utils/EventBus";
    export default {
        name: "FinanceArea",
        components:{SelectX},
        props: {
            financial_movements: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            showModal(entity) {
                EventBus.showFinMov(entity => {
                    const idx = this.financial_movements.indexById(entity);
                    this.$set(this.financial_movements, idx, entity);
                }, {entity: entity});
            }
        },
        computed: {
            fins() {
                return this.financial_movements;
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/variables";

    .icon, .paid {
        &.in {
            color: green;
        }
        &.out {
            color: red;
        }
        svg {
            width: 1em;
            height: 1em;
        }
    }

    .inv {
        grid-area: inv;

        a {
            text-decoration: none;
            display: inline-block;
            margin-top: 1px;
            background: $theme_color_one;
            color: #fff;
            border-radius: 10px;
            padding: 0 5px;
            transition: background-color .2s ease;
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 5px;
            }

            &:hover {
              background-color: $theme_color_six;
              color: #fff;
            }
        }
    }

    .fin-item {
        display: grid;
        grid-gap: 5px;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
        grid-template-areas: 'ident ident value' 'emit sched paid' 'inv inv inv' 'notes notes notes';
        padding-right: 5px;
        padding-left: 5px;

        &:not(:first-child) {
            border-top: 1px solid #e7eaec;
        }

        .icon, .paid {
            svg {
                margin-top: -5px;
            }
        }

        .paid {
            margin-left: 5px;
        }

        .ident {
            grid-area: ident;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .value {
            grid-area: value;
            text-align: right;
            font-weight: 700;
        }

        .emit {
            grid-area: emit;
        }
        .sched {
            grid-area: sched;
            text-align: center;
        }
        .paid {
            grid-area: paid;
            text-align: right;
        }

        .notes {
            grid-area: notes;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }
</style>
